import WalletOutlined from '@ant-design/icons/WalletOutlined';
import SwapOutlined from '@ant-design/icons/SwapOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import FileProtectOutlined from '@ant-design/icons/FileProtectOutlined';
import { t } from 'i18n';

const finance = {
  id: 'group-finance',
  title: t('Finance'),
  type: 'group',
  children: [
    { id: 'wallets', title: t('Wallets'), type: 'item', url: '/finance/wallets', icon: WalletOutlined },
    { id: 'wallet-transactions', title: t('Transactions'), type: 'item', url: '/finance/transactions', icon: SwapOutlined },
    { id: 'wallet-topup-requests', title: t('Top-Up Requests'), type: 'item', url: '/finance/topup-requests', icon: FileProtectOutlined },
    { id: 'platform-settings', title: t('Platform Settings'), type: 'item', url: '/finance/settings', icon: SettingOutlined }
  ]
};

export default finance;
